import OWContainer from 'styles/styled-components/ow-container';
import { MaterialReactTable } from 'material-react-table';
import useController from '../controllers/promotion-controller';
import React from 'react';
import { Box, Typography } from '@mui/material';
import TableTabs from 'components/controls/table-tabs';
import { ResponsePlaceDto } from 'features/place/types/dtos';

export const PromotionsRoute = () => {
    const { tableSettings, placeId, places, activePlace, handleAddPromotion, handleTabChange } = useController();

    if (places?.content.length === 0) {
        return (
            <Box>
                <Typography>This website has no places</Typography>
            </Box>
        );
    }

    return (
        <React.Fragment>
            {placeId !== '' && (
                <TableTabs<ResponsePlaceDto>
                    active={!!activePlace}
                    id={placeId}
                    handleAdd={handleAddPromotion}
                    handleTabChange={handleTabChange}
                    tabData={places?.content}
                >
                    {activePlace && (
                        <OWContainer>
                            <MaterialReactTable table={tableSettings} />
                        </OWContainer>
                    )}
                </TableTabs>
            )}
        </React.Fragment>
    );
};
